const styles = {
    mainContainer: {
        width: "100%",
        height: '"100%"'
    },
    gridContainer:{
        boxSizing: "border-box",
        height: "600px",
        width: "100%",
        backgroundColor: 'white',
        fontSize: 12
    },
    cellWrapText :{
        whiteSpace: 'normal'
    }
  };

  export default styles;



// WEBPACK FOOTER //
// ./src/components/table/styles/AgGridTableCtrlStyles.js